import React from 'react'
import { careersAPI } from '../../services/api'

export function renderCareers(ctx) {
  const {
    activeTab,
    careersMsgMap,
    created,
    editingJobId,
    jobApplications,
    jobForm,
    jobListings,
    lang,
    selectedApplication,
    setCareersMsgMap,
    setEditingJobId,
    setJobApplications,
    setJobForm,
    setJobListings,
    setSelectedApplication,
    setShowJobForm,
    showJobForm,
    updated,
  } = ctx
  return (
    <>
          {activeTab === 'careers' && (() => {
            const STATUS_COLORS = { pending: '#f59e0b', reviewing: '#3b82f6', accepted: '#10b981', rejected: '#ef4444' }
            const pendingApps = jobApplications.filter(a => a.status === 'pending').length

            const handleStatusChange = async (appId, status) => {
              const notes = careersMsgMap[appId] || ''
              try {
                const updated = await careersAPI.updateApplicationStatus(appId, status, notes)
                setJobApplications(prev => prev.map(a => a.id === appId ? { ...a, ...updated } : a))
              } catch {}
            }

            const handleSaveJob = async () => {
              try {
                if (editingJobId) {
                  const updated = await careersAPI.updateJob(editingJobId, jobForm)
                  setJobListings(prev => prev.map(j => j.id === editingJobId ? updated : j))
                } else {
                  const created = await careersAPI.createJob(jobForm)
                  setJobListings(prev => [created, ...prev])
                }
                setShowJobForm(false)
                setEditingJobId(null)
                setJobForm({ title: '', department: '', location: '', type: 'Full-time', description: '', requirements: '', is_active: true })
              } catch {}
            }

            const handleDeleteJob = async (id) => {
              if (!window.confirm('Delete this job listing?')) return
              try {
                await careersAPI.deleteJob(id)
                setJobListings(prev => prev.filter(j => j.id !== id))
              } catch {}
            }

            const handleToggleActive = async (job) => {
              try {
                const updated = await careersAPI.updateJob(job.id, { ...job, is_active: !job.is_active })
                setJobListings(prev => prev.map(j => j.id === job.id ? updated : j))
              } catch {}
            }

            return (
              <div className="dash-section">
                <div className="dash-section-header">
                  <h2>💼 {lang === 'fr' ? 'Carrières & Candidatures' : 'Careers & Applications'}</h2>
                  <p>{lang === 'fr' ? 'Gérer les offres d\'emploi et les candidatures reçues.' : 'Manage job listings and received applications.'}</p>
                </div>

                {/* Stats */}
                <div style={{ display: 'flex', gap: 16, marginBottom: 28, flexWrap: 'wrap' }}>
                  {[
                    { label: 'Active Jobs', value: jobListings.filter(j => j.is_active).length, color: '#10b981' },
                    { label: 'Total Applications', value: jobApplications.length, color: '#3b82f6' },
                    { label: 'Pending Review', value: pendingApps, color: '#f59e0b' },
                    { label: 'Accepted', value: jobApplications.filter(a => a.status === 'accepted').length, color: '#6366f1' },
                  ].map(s => (
                    <div key={s.label} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: '16px 24px', minWidth: 130 }}>
                      <div style={{ fontSize: '1.8rem', fontWeight: 800, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: '0.78rem', color: '#6b7280', fontWeight: 600 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Job Listings */}
                <div style={{ marginBottom: 32 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ margin: 0 }}>{lang === 'fr' ? 'Offres d\'emploi' : 'Job Listings'}</h3>
                    <button className="dash-btn primary small" onClick={() => { setShowJobForm(true); setEditingJobId(null); setJobForm({ title: '', department: '', location: '', type: 'Full-time', description: '', requirements: '', is_active: true }) }}>
                      + Add Job
                    </button>
                  </div>

                  {showJobForm && (
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: 24, marginBottom: 20 }}>
                      <h4 style={{ margin: '0 0 16px' }}>{editingJobId ? 'Edit Job' : 'New Job Listing'}</h4>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                        {[['title','Title *'],['department','Department'],['location','Location'],['type','Type']].map(([k,l]) => (
                          <div key={k}>
                            <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 4 }}>{l}</label>
                            {k === 'type' ? (
                              <select className="dash-input" value={jobForm[k]} onChange={e => setJobForm(f => ({ ...f, [k]: e.target.value }))}>
                                {['Full-time','Part-time','Contract','Internship'].map(o => <option key={o}>{o}</option>)}
                              </select>
                            ) : (
                              <input className="dash-input" value={jobForm[k]} onChange={e => setJobForm(f => ({ ...f, [k]: e.target.value }))} placeholder={l} />
                            )}
                          </div>
                        ))}
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 4 }}>Description</label>
                        <textarea className="dash-input" style={{ width: '100%', minHeight: 80, resize: 'vertical', boxSizing: 'border-box' }} value={jobForm.description} onChange={e => setJobForm(f => ({ ...f, description: e.target.value }))} />
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 4 }}>Requirements</label>
                        <textarea className="dash-input" style={{ width: '100%', minHeight: 80, resize: 'vertical', boxSizing: 'border-box' }} value={jobForm.requirements} onChange={e => setJobForm(f => ({ ...f, requirements: e.target.value }))} />
                      </div>
                      <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                        <button className="dash-btn primary small" onClick={handleSaveJob} disabled={!jobForm.title}>Save</button>
                        <button className="dash-btn secondary small" onClick={() => { setShowJobForm(false); setEditingJobId(null) }}>Cancel</button>
                      </div>
                    </div>
                  )}

                  <div style={{ overflowX: 'auto' }}>
                    <table className="dash-table">
                      <thead><tr><th>Title</th><th>Dept.</th><th>Location</th><th>Type</th><th>Status</th><th>Actions</th></tr></thead>
                      <tbody>
                        {jobListings.map(job => (
                          <tr key={job.id}>
                            <td style={{ fontWeight: 600 }}>{job.title}</td>
                            <td>{job.department || '—'}</td>
                            <td>{job.location || '—'}</td>
                            <td>{job.type}</td>
                            <td>
                              <span style={{ padding: '2px 10px', borderRadius: 999, fontSize: '0.72rem', fontWeight: 700, background: job.is_active ? '#dcfce7' : '#f3f4f6', color: job.is_active ? '#166534' : '#6b7280', border: job.is_active ? '1px solid #bbf7d0' : '1px solid #e5e7eb' }}>
                                {job.is_active ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: 6 }}>
                                <button className="dash-btn secondary small" onClick={() => { setEditingJobId(job.id); setJobForm({ title: job.title, department: job.department || '', location: job.location || '', type: job.type || 'Full-time', description: job.description || '', requirements: job.requirements || '', is_active: job.is_active }); setShowJobForm(true) }}>Edit</button>
                                <button className="dash-btn secondary small" onClick={() => handleToggleActive(job)}>{job.is_active ? 'Deactivate' : 'Activate'}</button>
                                <button className="dash-btn danger small" onClick={() => handleDeleteJob(job.id)}>Delete</button>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {jobListings.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', color: '#9ca3af', padding: '24px' }}>No job listings yet.</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Applications */}
                <div>
                  <h3 style={{ marginBottom: 16 }}>{lang === 'fr' ? 'Candidatures reçues' : 'Received Applications'}</h3>
                  <div style={{ overflowX: 'auto' }}>
                    <table className="dash-table">
                      <thead><tr><th>Name</th><th>Email</th><th>Position</th><th>Dept.</th><th>Date</th><th>Resume</th><th>Status</th><th>Notes</th><th>Actions</th></tr></thead>
                      <tbody>
                        {jobApplications.map(app => (
                          <tr key={app.id}>
                            <td style={{ fontWeight: 600 }}>{app.applicant_name}</td>
                            <td style={{ fontSize: '0.82rem' }}>{app.applicant_email}</td>
                            <td>{app.job_title || <span style={{ color: '#9ca3af' }}>General</span>}</td>
                            <td style={{ fontSize: '0.82rem', color: '#6b7280' }}>{app.department || '—'}</td>
                            <td style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{new Date(app.applied_at).toLocaleDateString()}</td>
                            <td>
                              {app.resume_path
                                ? <button type="button" className="dash-btn secondary small" onClick={() => careersAPI.downloadResume(app.id, app.resume_original_name || 'resume').catch(err => alert(err.message))}>📄 {app.resume_original_name?.slice(0, 18) || 'CV'}</button>
                                : <span style={{ color: '#9ca3af', fontSize: '0.82rem' }}>—</span>}
                            </td>
                            <td>
                              <select
                                className="dash-input"
                                style={{ padding: '4px 8px', fontSize: '0.8rem', minWidth: 110, color: STATUS_COLORS[app.status] || '#374151', fontWeight: 700 }}
                                value={app.status}
                                onChange={e => handleStatusChange(app.id, e.target.value)}
                              >
                                {['pending','reviewing','accepted','rejected'].map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                              </select>
                            </td>
                            <td>
                              <input
                                className="dash-input"
                                style={{ padding: '4px 8px', fontSize: '0.8rem', minWidth: 140 }}
                                placeholder="Add note…"
                                value={careersMsgMap[app.id] ?? (app.notes || '')}
                                onChange={e => setCareersMsgMap(m => ({ ...m, [app.id]: e.target.value }))}
                              />
                            </td>
                            <td style={{ display: 'flex', gap: 6 }}>
                              <button className="dash-btn secondary small" onClick={async () => {
                                try {
                                  const detail = await careersAPI.getApplication(app.id)
                                  setSelectedApplication(detail)
                                } catch (err) {
                                  alert(err.message)
                                }
                              }}>{lang === 'fr' ? 'Détail' : 'Detail'}</button>
                              <button className="dash-btn primary small" onClick={() => handleStatusChange(app.id, app.status)}>Save</button>
                            </td>
                          </tr>
                        ))}
                        {jobApplications.length === 0 && <tr><td colSpan={9} style={{ textAlign: 'center', color: '#9ca3af', padding: '24px' }}>No applications received yet.</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>

                {selectedApplication && (
                  <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={() => setSelectedApplication(null)}>
                    <div style={{ background: 'white', borderRadius: 16, maxWidth: 640, width: '100%', maxHeight: '85vh', overflow: 'auto', padding: 24, boxShadow: '0 20px 50px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 16 }}>
                        <div>
                          <h3 style={{ margin: 0 }}>{selectedApplication.applicant_name}</h3>
                          <p style={{ margin: '6px 0 0', color: '#6b7280', fontSize: '0.9rem' }}>{selectedApplication.applicant_email}</p>
                          <p style={{ margin: '4px 0 0', fontWeight: 600 }}>{selectedApplication.job_title || (lang === 'fr' ? 'Candidature générale' : 'General application')}</p>
                        </div>
                        <button className="dash-btn secondary small" onClick={() => setSelectedApplication(null)}>✕</button>
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#6b7280', marginBottom: 6 }}>{lang === 'fr' ? 'Lettre de motivation' : 'Cover letter'}</div>
                        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: 14, whiteSpace: 'pre-wrap', lineHeight: 1.5, fontSize: '0.92rem' }}>
                          {selectedApplication.cover_letter || <span style={{ color: '#9ca3af' }}>{lang === 'fr' ? 'Aucune lettre fournie.' : 'No cover letter provided.'}</span>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                        {selectedApplication.resume_path ? (
                          <button className="dash-btn primary small" onClick={() => careersAPI.downloadResume(selectedApplication.id, selectedApplication.resume_original_name || 'resume').catch(err => alert(err.message))}>
                            📄 {lang === 'fr' ? 'Télécharger le CV' : 'Download CV'} ({selectedApplication.resume_original_name || 'file'})
                          </button>
                        ) : (
                          <span style={{ color: '#9ca3af', fontSize: '0.85rem' }}>{lang === 'fr' ? 'Pas de CV' : 'No CV on file'}</span>
                        )}
                        <span style={{ fontSize: '0.82rem', color: '#6b7280' }}>{lang === 'fr' ? 'Statut' : 'Status'}: <strong>{selectedApplication.status}</strong></span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          })()}
    </>
  )
}
